<template>
    <div>
        <h1>{{ transl["STR_TITLE_DOCUMENTS"] }}</h1>
        {{ transl["STR_IFU"] }}
        <!-- <ul>
            <li><a href="https://shop.procomcure.com/dl/ifu.pdf" target="_blank">
                {{ transl["STR_IFU_FILE1"] }}
            </a></li>
        </ul> -->
        <ul>
            <li><a href="./docs/91172 PhoenixDx SARS-CoV-2 POC PCR Kit DE 2.4.3.pdf" target="_blank">
                IFU - SARS-CoV-2 POC PCR Kit
            </a></li>
        </ul>
        <ul>
            <li><a href="./docs/91266-PhoenixLife-Laktose-POC-PCR-Kit-DE-1.2.pdf" target="_blank">
                IFU - Laktose POC PCR Kit
            </a></li>
        </ul>
        <ul>
            <li><a href="./docs/91272-PhoenixDx-RSV-POC-PCR-Kit-DE-1.3.pdf" target="_blank">
                IFU - RSV POC PCR Kit
            </a></li>
        </ul>
        <ul>
            <li><a href="./docs/91274-PhoenixDx-Influenza-A-B-POC-PCR-Kit-DE-1.2.pdf" target="_blank">
                IFU - Influenza A/B POC PCR Kit
            </a></li>
        </ul>
    </div>
</template>
<style scoped>
a {
    text-decoration: none;
    color: black;
}
</style>
<script>
export default({
    props: [ 'transl' ],
    setup() {
    },
})
</script>
